module.exports = __webpack_public_path__ + "img/updated.c81e1e6a.svg";